export const routes = [
  {
    name: 'GroupList',
    path: '',
    component: () => import('./pages/GroupList.vue'),
    meta: {
      title: 'Группы',
      authorize: [],
    },
  },
  // {
  //   name: 'GroupView',
  //   path: '/:id/view',
  //   component: () => import('./pages/GroupView/index.vue'),
  //   meta: {
  //     title: 'Просмотр группы',
  //     authorize: [],
  //     breadcrumbs: {
  //       parent: 'GroupList',
  //     },
  //   },
  // },
  // {
  //   name: 'GroupAddUsers',
  //   path: '/:id/add-users',
  //   component: () => import('./pages/GroupAddUsers.vue'),
  //   meta: {
  //     title: 'Добавить пользователей в группу',
  //     authorize: [],
  //     breadcrumbs: {
  //       parent: 'GroupList',
  //     },
  //   },
  // },
  {
    name: 'TaskCheck',
    path: '/task/:id/answers',
    component: () => import('./pages/TaskCheck/index.vue'),
    meta: {
      title: 'Ответы на задание',
      authorize: [],
    },
  },
  {
    name: 'TaskCheckAnalytic',
    path: '/task/:id/answers-analytic',
    component: () => import('./pages/TaskCheck/Analytic.vue'),
    meta: {
      title: 'Аналитика ответов',
      authorize: [],
    },
  },
  {
    name: 'GroupChat',
    path: '/:id/chat',
    component: () => import('./pages/GroupChat.vue'),
    meta: {
      title: 'Чат',
      authorize: [],
      breadcrumbs: {
        parent: 'GroupList',
      },
    },
  },
];

export default routes;
